import React from 'react';
import { Box, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Wrapper } from '../Halls/List/styles';
import HallBox from '../Tables/List/hall-box';
import { hallSelector } from '../../redux/hallReducer';
import { useSelector } from 'react-redux';
import Preloader from '../Common/Preloader';
import { useFindJackpotsQuery } from '../../api/jackpot';
import JackpotError from './error';
import CompleteTable from './complete-table';
import { Link } from "react-router-dom";
import { Pagination } from '@material-ui/lab';

interface CompleteJackpotsProps {
    isModal?: boolean;
    hallId: number;
    setHallId: (hallId: number) => void;
}

const CompleteJackpots: React.FC<CompleteJackpotsProps> = React.memo(({ isModal, hallId, setHallId }) => {
    const [t] = useTranslation();
    const { halls: { data: halls } } = useSelector(hallSelector);
    const [pagination, setPagination] = React.useState({ hallId, page: 1 });
    const page = pagination.hallId === hallId ? pagination.page : 1;
    const { currentData: result, isFetching: loading, error } = useFindJackpotsQuery(
        { status: [2, 3, 4], halls: [hallId], page, perPage: 10 }, { skip: !hallId }
    );
    const lastPage = result?.meta.pageCount || 1;
    React.useEffect(() => {
        if (!hallId && halls.length) {
            setHallId(halls[0].id);
        }
    }, [halls, hallId, setHallId]);
    //Jackpot::STATUS_ACTIVE, Jackpot::STATUS_ACCUMULATION_ONLY, Jackpot::STATUS_PAUSED, Jackpot::STATUS_COMPLETED
    return <Wrapper isModal={isModal}>
        <Box style={{ minWidth: '968px' }}>
            {!isModal && <Box display="flex" justifyContent="space-between">
                <h2>{t('ru.jackpots.title')} <Link to="/jackpots"><Button variant="contained" color="primary" size="small">посмотреть текущие</Button></Link></h2>
            </Box>}
            {hallId > 0 && <div style={{ position: 'relative' }}>
                <JackpotError error={error} />
                <HallBox hallId={hallId} setHallId={id => { setPagination({ hallId: id, page: 1 }); setHallId(id); }} halls={halls} />
                {loading ? <Preloader /> : <CompleteTable jackpots={result?.items || []} hall_id={hallId} />}
            </div>}
            {lastPage > 1 && <Pagination variant="outlined" shape="rounded" siblingCount={0} count={lastPage} page={page} onChange={(e, value) => setPagination({ hallId, page: value })} />}
        </Box>
    </Wrapper>;
});

export default CompleteJackpots;
